import UpArrow from './UpArrow';

export default UpArrow;
